import { call, select } from 'redux-saga/effects';
import { axiosLayer7Client, getEnvironment } from '../../../config/axios-clientFilView';
import API_CONFIG from '../../../config/API-config.json';
import constants from '../../../constants/api/services';

const handleLogOutRedirect = loc => {
  sessionStorage.clear();
  //const userName =
  //localStorage.getItem('userName') !== null ? localStorage.getItem('userName') : '';
  //localStorage.clear();
  //localStorage.setItem('userName', userName);
  if (loc.startsWith('#')) {
    window.location.hash = loc;
  } else {
    window.location.href = loc;
  }
  // window.location.reload();
};

export function* handleSessionLogoutSaga() {
  yield call(axiosLayer7Client.post, constants.logout);
}

export function* logoutSaga() {
  try {
    if (window.location.hash !== '#/logout') {
      const { global, userdetails } = yield select();
      const { region } = global.globalData;
      const sso = userdetails.sso;
      // let redirectHash = region === 'FIC' ? '#/ca' : '#/login';
      // const userRole = sessionStorage.getItem('role');
      // yield call(axiosLayer7Client.post, constants.logout);
      // if (userRole === 'SUPER' || userRole === 'RDCSM') {
      //   redirectHash = '#/logout';
      // } else {
      //   sessionStorage.setItem('role', '');
      // }
      sessionStorage.setItem('role', '');
      const { hostname, origin } = window.location;
      const redirectHash = `${
        API_CONFIG[getEnvironment(hostname)].REACT_APP_API_PING_LOGOUT
      }/startSLO.ping?TargetResource=${origin}${sso ? '/logout' : ''}`;
      handleLogOutRedirect(redirectHash);
    }
  } catch (err) {
    handleLogOutRedirect('#/login');
  }
}

export default logoutSaga;
